export const MonthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export function GetMonthsByYear(year: number, excludeFuture: boolean) {
  const dates: { value: Date; text: string }[] = [];

  for (let index = 0; index < 12; index++) {
    const x = new Date(year, 0, 1);
    x.setMinutes(0);
    x.setHours(0);
    x.setSeconds(0);
    x.setMilliseconds(0);
    x.setDate(1);
    x.setMonth(x.getMonth() + index);
    dates.push({
      value: x,
      text: `${MonthNames[x.getMonth()]} ${x.getFullYear()}`
    });
  }

  return excludeFuture ? dates.filter((x) => x.value < new Date()) : dates;
}

export function GetMonthStartAndEnd(x: Date) {
  const startYear = x.getUTCFullYear();
  const startMonth = x.getMonth() + 1;
  const startDay = x.getDate();

  const eom = new Date(startYear, startMonth, 0);
  const endDay = eom.getDate();

  return {
    startYear,
    startMonth,
    startDay,
    endDay
  };
}

export function GetYears(yearsBack: number) {
  const dates = [];
  for (let index = 0; index <= yearsBack; index++) {
    dates.push(new Date().getFullYear() - index);
  }
  return dates;
}

export function RemoveOffset(d: Date): Date {
  const output = new Date(d);
  output.setMinutes(-output.getTimezoneOffset());
  return output;
}

export function DayOfMonthSuffix(day: number) {
  if (day > 3 && day < 21) return 'th';
  switch (day % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
}

type Week = {
  week: number;
  start: number;
  end: number;
  startText: string;
  endText: string;
};

export function GetWeeksInMonth(month: number, year: number): Week[] {
  const weeks = [];
  const firstDate = new Date(year, month, 1);
  const lastDate = new Date(year, month + 1, 0);
  const numDays = lastDate.getDate();
  let start = 1;
  let end = firstDate.getDay() === 0 ? 1 : 8 - firstDate.getDay();
  let week = 1;

  while (start <= numDays) {
    const r: Week = {
      week,
      start,
      end: end > numDays ? numDays : end,
      startText: '',
      endText: ''
    };

    r.endText = `${r.end}${DayOfMonthSuffix(r.end)}`;
    r.startText = `${r.start}${DayOfMonthSuffix(r.start)}`;

    weeks.push(r);
    start = end + 1;
    end = end + 7;
    week++;
  }
  return weeks;
}
